// TODO: this is temporary. We will replace this with a merchant-defined metafield key
export const VARIANT_PICKER_COLOR_HEX_METAFIELD_KEY = "custom.redo_color_hex";
